import authRequest from "@/api/http/authRequest";

export default {
  createLoginAccessCode (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/login-access-code`, params, cb, errCb)
  },
  updateLoginAccessCode (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.patch(`/admin/login-access-code/${params.id}`, params, cb, errCb)
  },
  deleteLoginAccessCode (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/login-access-code/${id}`, cb, errCb)
  },
  search (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/login-access-code/search`, params, cb, errCb)
  },
}
